import { type RouteObject } from 'Routes/index';

import DocumentsRoutes from './Documents';

export const TaxClaimantFolder = 'Pages/Screens/TaxClaimant';

const TaxClaimantRoutes: RouteObject[] = [...DocumentsRoutes];

export default TaxClaimantRoutes;